import { shape } from '../global/shape';
import { palette } from '../global/palette';
import { boxShadow } from '../global/shadows';
export const MuiMenu = {
    MuiMenu: {
        styleOverrides: {
            paper: {
                borderRadius: shape.borderRadius,
                padding: 0,
                boxShadow: boxShadow.medium,
            },
            list: {
                color: palette.common.black,
            },
        },
        defaultProps: {
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            },
            transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            },
        },
    },
};
